import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import List from './List';
import Detail from './Detail';
import Add from './Add';
import StartTime from './StartTime';
import ActiveTime from './ActiveTime';
import DailySummary from './DailySummary';
import ActiveTask from './ActiveTask';
import PrivateRoute from '~/app/PrivateRoute';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';

export const TIME_MANAGEMENT_ROUTES = {
  list: '/timeManagement',
  details: '/timeManagement/calender',
  addTimeForm: '/timeManagement/addTimeForm',
  startTime:'/timeManagement/startTime',
  activeTime:'/timeManagement/activeTimer',
  dailySummary:'/timeManagement/dailySummary',
  activeTask:'/timeManagement/activeTask',
  editTimeForm: (id: string | number) => `/timeManagement/${id}`,
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {

  return (
    <RouterSuspense>
      <Switch>
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.details} component={Detail} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.startTime} component={StartTime} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.activeTime} component={ActiveTime} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.activeTask} component={ActiveTask} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.dailySummary} component={DailySummary} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.addTimeForm} component={Add} requiredPermissions={PERMISSION_GROUPS.timeManagement} />
        <PrivateRoute path="/timeManagement/:id" component={Add} requiredPermissions={PERMISSION_GROUPS.timeManagement} />
        <PrivateRoute path={TIME_MANAGEMENT_ROUTES.list} component={List} requiredPermissions={PERMISSION_GROUPS.timeRegistration} />
      </Switch>
    </RouterSuspense>
  );
};

export default Router;